// Third-party libraries
import React from "react";
import Typography from "@mui/material/Typography";

// Local modules
import Shape from "../../shapes/Shape.jsx";

export default function ShapeFilter({ state, dispatch }) {
  const { filters, searchQuery } = state;
  const shapeFilter = filters.find(function (filter) {
    return filter.name === "Shape";
  });

  function isActive(shapeName) {
    const selectedValue = searchQuery.fields.find(function (field) {
      return field.name === "Shape";
    });
    if (selectedValue) {
      const bool = selectedValue.values.find(function (value) {
        return value.name === shapeName ? true : false;
      });
      return bool;
    }
  }

  function selectShape(shapeName) {
    let updatedFields = searchQuery.fields.map((field) => ({
      ...field,
      values: [...field.values],
    }));

    const shapeFieldIndex = updatedFields.findIndex(
      (field) => field.name === "Shape"
    );
    const shapeField =
      shapeFieldIndex > -1 ? updatedFields[shapeFieldIndex] : null;

    if (shapeField) {
      // See if the shape is already selected
      const isShapeSelected = shapeField.values.some(
        (value) => value.name === shapeName
      );

      if (isShapeSelected) {
        // Remove the selected shape
        shapeField.values = shapeField.values.filter(
          (value) => value.name !== shapeName
        );

        // If no shapes left, remove the Shape field entirely
        if (shapeField.values.length === 0) {
          updatedFields = updatedFields.filter(
            (field) => field.name !== "Shape"
          );
        } else {
          updatedFields[shapeFieldIndex] = shapeField;
        }
      } else {
        // Add the new shape
        shapeField.values.push({ name: shapeName });
        updatedFields[shapeFieldIndex] = shapeField;
      }
    } else {
      // No Shape field yet: add it with this shape as the first value
      updatedFields.push({
        name: "Shape",
        values: [{ name: shapeName }],
      });
    }

    // Update the query
    dispatch({ type: "updateSearchQuery", payload: updatedFields });
  }

  return (
    <div className="filter filter--shape">
      {shapeFilter.values.map((value) => (
        <div
          key={value.name}
          onClick={() => selectShape(value.name)}
          className="shape-value"
        >
          <div className="shape-icon pointer">
            <Shape
              type={value.name}
              color={isActive(value.name) ? "black" : "#4280aa"}
              stroke_width={isActive(value.name) ? "1%" : "0.4%"}
              width="40"
            />
          </div>
          <Typography
            variant="body3"
            className={[
              "pointer",
              "shape-label " +
                (isActive(value.name) ? "shape-label--selected" : ""),
            ].join(" ")}
          >
            {value.name}
          </Typography>
        </div>
      ))}
    </div>
  );
}
